import { render } from "./HeroiconsOutlineUserGroup.vue?vue&type=template&id=bb394164"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserGroup.vue"]])

export default __exports__